<!--年龄 Age-->
<template>
	<div class="question-container" style="border: 1px solid #edeff2">
		<div class="question-type">年龄</div>
		<div class="title-view" :style="{ marginRight: '' }">
			<p style="color: #4c4a56">
				<span v-if="dataObj.isMust === 1" class="asterisk">*</span>
				{{ `${index + 1}、` }}
				<span style="color: #4c4a56">
					{{ `${dataObj.caseProblem}` }}
				</span>
			</p>
		</div>
		<div class="question-images">
			<div v-for="(item, index) in images" :key="index" style="margin-top: 10px; position: relative">
				<img :src="item" mode="widthFix" style="width: 100%" />
			</div>
		</div>
		<div v-for="(item, index) in list" :key="index">
			<div class="choose-css choose-css-new" :class="{ active: item.isChoose }" style="
          border: 1px solid rgba(237, 237, 237, 0.5);
          background: rgba(247, 247, 247, 1);
        " @click="handleChoose(item, index)">
				<div class="choose-css-text">
					<p style="
              white-space: normal;
              word-break: break-all;
              color: rgba(43, 47, 54, 1);
            ">
						{{ item.text }}
					</p>
					<div class="select-icon" style="
              border: 1px solid rgba(237, 237, 237, 1);
              background: #ffffff;
            "></div>
				</div>

				<div class="question-images">
					<div class="question-images-box" @click.stop="showBigImage(imgItem, item)"
						v-for="(imgItem, imgIndex) in item.img_path" :key="imgIndex"
						style="margin-top: 10px; position: relative">
						<img :src="imgItem" mode="aspectFill" class="thumbnail-image" />
						<div class="fangda-box">查看图片</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			params: {
				type: Object,
				default: {},
			},
		},
		data() {
			return {
				dataObj: {},
				answerObj: {},
				index: 0,
				list: [],
				count: 3,
				isMultiple: true,

				images: [],
				rules: [],
			};
		},
		methods: {},
		watch: {
			params: {
				handler(newVal) {
					this.dataObj = newVal.data;
					this.index = newVal.index;
					this.images = JSON.parse(newVal.data.caseProblemImg || '[]');
					this.list = JSON.parse(newVal.data.chooseList || '{"list":[]}').list;

					for (var i = 0; i < this.list.length; i++) {
						this.list[i].isChoose = false;
					}

					if (newVal.answer && newVal.answer.answer) {
						var answers = newVal.answer.answer;
						for (var i = 0; i < this.list.length; i++) {
							var item = this.list[i];
							for (var j = 0; j < answers.length; j++) {
								if (answers[j].id === item.id) {
									item.isChoose = true;
									item.fill_prompt = answers[j].context || '';
									break;
								}
							}
						}
					}
				},
				deep: true,
				immediate: true,
			},
		},
	};
</script>

<style scoped>
	.question-logic {
		position: absolute;
		right: 13px;
		top: 28px;
		width: 13px;
		height: 12px;
	}

	.choose-css-new.active .select-icon {
		background: rgba(58, 96, 255, 1) !important;
		position: relative;
	}

	.choose-css-new.active .select-icon::after {
		display: block;
		content: "";
		width: 6px;
		height: 10px;
		border-right: 2px solid #fff;
		border-bottom: 2px solid #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(45deg);
		margin-top: -2px;
	}
</style>


// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewAge.vue